import { StateService } from "@uirouter/angularjs";
import { IOnInit } from "angular";

import { Record } from "../../../../../records/server/crud";

export class DownloadFileDetailController implements IOnInit {
  static $inject = ["$state"];
  downloadFileDetail!: Record;
  gridOptions: any = {
    columnDefs: [
      { headerName: "Serial Number", field: "SerialNumber" },
      {
        headerName: "Manufacturer",
        valueGetter: (params: any) => params.data.Machine?.MachineManufacturer?.Name || ""
      },
      {
        headerName: "Model",
        valueGetter: (params: any) => params.data.Machine?.MachineModelNumber?.Name || ""
      },
      {
        headerName: "Cabinet",
        valueGetter: (params: any) => params.data.Machine?.MachineCabinetType?.Name || ""
      }
    ],
    rowData: [],
    onGridReady: (params: any) => {
      this.gridOptions.api = params.api;
      this.gridOptions.columnApi = params.columnApi;
      this.gridOptions.api.sizeColumnsToFit();
    },
  };
  
  
  constructor(
    private readonly $state: StateService
  ) {}

  $onInit(): void {
    this.gridOptions.rowData = this.downloadFileDetail.Machines;
  }

  detailPage(machineId: number) {
    this.$state.go("main.machines.detail.configurations", { machineId });
  }
}
